import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { REFERRAL_BUILD_MARKER, TICKER_BUILD_MARKER } from "@/lib/featureFlags";
import { LOCKDOWN_BUILD_MARKER } from "@/lib/appReview";

// T49.Q / T49.R — Side-effect anchors so webpack keeps the
// compile-time build markers as literals in the production bundle.
// release-gate.sh greps the built JS for these constants to verify
// the .ipa actually carries the App-Review-safe state (env-derived
// referral marker + source-level lockdown marker).
// Build 85 — TICKER marker joins the anchor set.
if (typeof window !== "undefined") {
  window.__tlBuildMarker = REFERRAL_BUILD_MARKER;
  window.__tlLockdownMarker = LOCKDOWN_BUILD_MARKER;
  window.__tlTickerMarker = TICKER_BUILD_MARKER;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
